import api, { handleError, handleResponse } from '../';

export const getDeliveryVenues = (handle: string, flow: string) => {
    return api
        .get('delivery-venues', { params: { handle, flow } })
        .then((response) => handleResponse(response))
        .catch((error) => handleError(error));
};

export const filterDeliveryVenues = (handle: string, search: string) => {
    return api
        .get('delivery-venues/filter', { params: { handle, search } })
        .then((response) => handleResponse(response))
        .catch((error) => handleError(error));
};
